import Vue from 'vue'
import Vuetify, {
	VForm,
	VContainer,
	VRow,
	VCol,
	VTextField,
	VTextarea,
	VSelect,
	VRadioGroup,
	VRadio,
	VCard,
	VCardText,
	VCheckbox,
	VBtn,
	VSnackbar,
	VProgressCircular,
} from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
	VForm,
	VContainer,
	VRow,
	VCol,
	VTextField,
	VTextarea,
	VSelect,
	VRadioGroup,
	VRadio,
	VCard,
	VCardText,
	VCheckbox,
	VBtn,
	VSnackbar,
	VProgressCircular,
  },
})

const opts = {

	icons: {
    iconfont: 'mdi',
  },
}

export default new Vuetify(opts)
